<!-- eslint-disable no-trailing-spaces -->
<!-- eslint-disable dot-notation -->
<template>
    <div class="d-flex main-container">
      <!-- Side Menu -->
      <!-- In your main component template, replace the side menu section with: -->
       <div class="side-nav">
          <side-menu 
            :active-item="activeMenu" 
            @menu-change="handleMenuChange"
          />
      </div>
  
      
      <!-- Main Content -->
      <div class="main-content">
        <b-container class="touchpoint-dashboard">
          <b-card class="dashboard-card content-card">
      
            <!-- Data Table Section -->
            <b-card-body>
              <!-- Replace the current flex container with Bootstrap grid -->
              <div class="row mb-0" name="data-squares">
                <div class="col-xl-4 col-lg-6 col-12 mb-3">
                  <div class="p-3 d-flex flex-column h-100 data-square">
                    <!-- Date Range -->
                    <div class="flex row justify-content-between pr-3 pl-3">
                      <h5 class="mb-3">Filter</h5>

                      <div>
                        <b-button 
                          @click="subtractDay"
                          variant="light"
                          style="background-color: dimgray; height: 2em; font-weight: bolder;"
                          class="b-flex justify-content-between align-items-center">
                          <font-awesome-icon style="height: 100%; width: 100%;" :icon="icons.faAngleLeft" class="text-white"/>
                        </b-button>
                        
                        <b-button 
                          @click="addDay"
                          variant="light"
                          style="background-color: dimgray; height: 2em; font-weight: bolder;"
                          class="b-flex justify-content-between align-items-center">
                          <font-awesome-icon style="height: 100%; width: 100%;" :icon="icons.faAngleRight" class="text-white"/>
                        </b-button>
                      </div>

                    </div>
                    
                    <div class="mb-3">
                      <label for="date-range-picker" class="font-weight-bold d-block mb-2 text-muted"><h6>Date Range:</h6></label>
                        <b-input-group class="d-flex flex-row gap-2">
                          <b-form-datepicker 
                            id="start-date-picker" 
                            :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric', weekday: 'long' }"
                            nav-button-variant="dark"
                            selected-variant="secondary"
                            v-model="filters.startDate"
                            :max="filters.endDate"
                            class="w-50"
                          ></b-form-datepicker>
                          <b-form-datepicker 
                            id="end-date-picker" 
                            :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric', weekday: 'long' }"
                            nav-button-variant="dark"
                            selected-variant="secondary"
                            v-model="filters.endDate"
                            :min="filters.startDate"
                            class="w-50"
                          ></b-form-datepicker>
                        </b-input-group>
                    </div>

                    <!-- Location -->
                    <div class="mb-3">
                      <label for="location-select" class="font-weight-bold d-block mb-2 text-muted"><h6>Location:</h6></label>
                      <b-form-select 
                        id="location-select" 
                        v-model="filters.location" 
                        :options="myLocations" 
                        class="w-100"
                      ></b-form-select>
                    </div>

                    <!-- Go Button - Using mt-auto to push to bottom and flex-grow for spacing -->
                    <div class="mt-auto pt-3">
                      <b-button 
                        variant="success"
                        class="w-100"
                        @click="fetchData" 
                        :disabled="loading"
                        size="md"
                      >
                        <i class="fas fa-sync-alt me-2"></i>
                        {{ loading ? 'Loading...' : 'Fetch Data' }}
                      </b-button>
                    </div>
                  </div>
                </div>
                
                <div class="col-xl-8 col-lg-6 col-12 mb-3">

                  <div class="sales-data">
                    <div class="p-3 h-100">
                      <b-button 
                        @click="exportToCSV"
                        variant="dark"
                        style="top: 1em; right: 1em; width: 5em; height: 2em; font-weight: bolder;"
                        class="position-absolute d-flex justify-content-between align-items-center px-2">
                        CSV
                        <font-awesome-icon :icon="icons.faDownload" class="text-white"/>
                      </b-button>
                      <h5 class="mb-3">Catering Stats:</h5>
                      <div>
                        <div class="row">
                            <div class="col-md-4">
                                <small class="text-muted d-block">Open Orders</small>
                                <span class="h4">{{ openOrdersCount }}</span>
                            </div>
                            <div class="col-md-4">
                                <small class="text-muted d-block">Avg. Revenue</small>
                                <span class="h4">${{ averageOrderRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                            </div>
                            <div class="col-md-4">
                                <small class="text-muted d-block">Next Due In</small>
                                <span class="h4">{{ nextOrderDueText }}</span>
                            </div>
                            </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>

              <b-table
                striped
                hover
                :items="filteredData"
                :fields="fields"
                :filter="filters.search"
                :busy="loading"
                show-empty
                responsive
                class="sales-table"
                >
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
  
                <template #empty>
                  <div class="text-center text-muted">
                    <h4>No Orders Available</h4>
                    <p>Please refresh or change search parameters to load new orders</p>
                  </div>
                </template>

                <template #cell(item_names)="data">
                    <ul class="mb-0">
                        <li 
                        v-for="(item, index) in (data.value || '').split(';').filter(i => i !== 'Catering Delivery Fee')" 
                        :key="index"
                        >
                        {{ item }}
                        </li>
                    </ul>
                </template>
  
                <!-- Format with custom display values -->
                 <template #cell(order_started)="data">
                    {{ data.value ? new Date(data.value).toLocaleDateString('en-US') : '' }}
                </template>

                <template #cell(order_due)="data">
                    {{ data.value ? new Date(data.value).toLocaleString('en-US', { 
                        year: 'numeric', 
                        month: 'numeric', 
                        day: 'numeric', 
                        hour: 'numeric', 
                        minute: '2-digit', 
                        hour12: true 
                    }) : 'N/A' }}
                </template>
                
                 <template #cell(time_remaining)="data">
                {{ data.value ? `${data.value} Days` : 'N/A' }}
                </template>

                <template #cell(total_settlement)="data">
                    ${{ ((data.value || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </template>
              </b-table>
  
              <div class="d-flex justify-content-between align-items-center mt-3">
                <div>
                  <strong>Total Records:</strong> {{ filteredData.length }}
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-container>
      </div>
    </div>
  </template>
  
<!-- eslint-disable no-trailing-spaces -->
<script>
    import { DateTime } from "luxon";
    import AuthMixin from "../../mixins/auth.mixin";
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import SideMenu from '@/components/admin-nav.vue';
    import { Api } from "shared/api";
    import { apiHandler } from "@/services/api-handler";

    import { 
        faDollarSign, 
        faTruck, 
        faBicycle, 
        faStore, 
        faSyncAlt,
        faTrash,
        faCheckCircle,
        faChartLine,
        faDownload,
        faExclamationTriangle,
        faAngleRight,
        faAngleLeft
    } from '@fortawesome/free-solid-svg-icons';


    export default {
        name: 'tp-timeline',
        mixins: [AuthMixin],
        components: {
        SideMenu,
        FontAwesomeIcon
    },
    data() {
    const now = DateTime.now().setZone('America/New_York');
    const previousSunday = now.set({ weekday: 7 }).minus({ weeks: 4 });


    const lastDay = now;

    // Helper function to format date
    const formatDate = (date) => {
        return date.toFormat('yyyy-MM-dd');
    };

    return {
        loading: false,
        connectionTested: false,
        connectionError: null,
        tableData: [],
        activeMenu: 'Catering',
        filters: {
            startDate: formatDate(previousSunday),
            endDate: formatDate(lastDay),
            location: 'loading',
            query: 'Menu Item Matrix'    ,
            search: ''       
        },
        myLocations: [],
        locationOptions: [
            { value: 'admin', text: 'All Locations', number: null },
            { value: 'cs001~6a6861cee116a411daf7257b768684f11', text: 'Royal Oak - 11 Mile', number: '1' },
            { value: 'cs002~c99923bf0c29c39e512f9cd5a1ccffb71', text: 'Royal Oak - Woodward', number: '2' }, 
            { value: 'cs003~53c0e59c5fb5a4b676717978476b2cbb1', text: 'Warren - Ryan', number: '3' },
            { value: 'cs004~2c16af0ed018da5378e45c0d933d2abe1', text: 'Warren - Schoenherr', number: '4' },           { value: 'admin', text: 'All Locations', number: null },
            { value: 'cs005~b46e2e33bd41887baa27551ff98621a61', text: 'New Baltimore', number: '5' },
            { value: 'cs006~9066e49435610ebbdaa8df630b5df3761', text: 'Grosse Pointe', number: '6' },
            { value: 'cs007~f809e2deca9605fab245518e0340dd3b1', text: 'St. Clair Shores', number: '7' },
            { value: 'cs008~57296834507ff8a37faf4f393bbddde51', text: 'Lincoln Park', number: '8' },
            { value: 'cs009~1f38264643f0c3890262073e3b97588c1', text: 'Sterling Heights', number: '9' },
            { value: 'cs010~cc0cab7dc43218119bb8cf2f298860611', text: 'Westland', number: '10' },
            { value: 'cs011~703345b217d1b56b60b447a1b6ff5a441', text: 'Macomb Township', number: '11' },
            { value: 'cs012~52c1952e9adbb62d1acec487b8b568551', text: 'Rochester', number: '12' },
            { value: 'cs013~ea4602ebe1e3dd4066e2369bc91f34f11', text: 'Detroit', number: '13' },
            { value: 'cs014~b9c028ce92edde3680eacfee75b701ae1', text: 'Clarkson', number: '14' },
            { value: 'cs015~4e5ece70d119ca0bb8f94502e95ac1191', text: 'Clawson', number: '15' },
            { value: 'cs016~ed873ecd067cd8608e6c19b1bbb36b341', text: 'Southfield', number: '16' },
            { value: 'cs017~8d3b502ef4ddc533b78c6310e43550601', text: 'Livonia', number: '17' },
            { value: 'cs018~cfdf796adf8452b0a55654a6530a25041', text: 'Riverview', number: '18' },
            { value: 'cs019~4d6704df7f00688bb3df6a8ddc1b93441', text: 'Clinton Township', number: '19' },
            { value: 'cs020~3556ff4772b8dbd30303cc5b4c3889a31', text: 'Shelby Township', number: '20' },
            { value: 'cs021~ff5907d6686f7d8267d2fd7b3f134da31', text: 'Brownstown', number: '21' },
            { value: 'cs022~6410a2fcaf82c9ba914ee9569e9832761', text: 'Bloomfield Township', number: '22' },
            { value: 'cs023~cf16d220ae79e94f7cfa13d5847cda311', text: 'Ypsilanti', number: '23' },
            { value: 'cs024~90cd7a9e6c3e34a8a15203dd8f5cfb211', text: 'Grand Blanc', number: '24' },
            { value: 'cs025~f597f3f279b81ebd354cab7ab184f68a1', text: 'Sterling Heights - 18 Mile', number: '25' },
            { value: 'cs026~6e124a7877a402b609e2d9b3da2dd2541', text: 'Oxford', number: '26' },
        ],
        fields: [
        // {
        // key: 'order_id',
        // label: 'id',
        // sortable: true,
        // class: 'text-left',
        // thStyle: { width: '10%', borderBottom: '3px solid orange' }
        // },
        {
            key: 'location',
            label: 'location',
            sortable: true,
            class: 'text-left',
            thStyle: { width: '10%', borderBottom: '3px solid orange' }
        },
        {
            key: 'order_started',
            label: 'placed',
            sortable: true,
            class: 'text-left',
            thStyle: { width: '5%', borderBottom: '3px solid purple' }
        },
        {
            key: 'order_due',
            label: 'due',
            sortable: true,
            class: 'text-left',
            thStyle: { width: '10%', borderBottom: '3px solid purple' }
        },
        {
            key: 'time_remaining',
            label: 'remaining',
            sortable: true,
            class: 'text-left',
            thStyle: { width: '10%', borderBottom: '3px solid purple' }
        },
        {
            key: 'Fulfilled',
            label: 'Fulfilled',
            sortable: true,
            class: 'text-left',
            thStyle: { width: '10%', borderBottom: '3px solid purple' }
        },
        {
            key: 'item_count',
            label: 'count', 
            sortable: true,
            class: 'text-left',
            thStyle: { width: '5%', borderBottom: '3px solid grey' }
        },
        {
            key: 'item_names',
            label: 'order',
            sortable: true,
            class: 'text-left',
            thStyle: { width: '20%', borderBottom: '3px solid grey' }
        },
        {
            key: 'order_notes',
            label: 'notes',
            sortable: true,
            class: 'text-left',
            thStyle: { width: '20%', borderBottom: '3px solid grey' }
        },
        {
            key: 'status',
            label: 'status',
            sortable: true,
            class: 'text-left',
            thStyle: { width: '10%', borderBottom: '3px solid grey' }
        },
        {
            key: 'total_settlement',
            label: 'total',
            sortable: true,
            class: 'text-left',
            thStyle: { width: '10%', borderBottom: '3px solid green'}
        }
        ],
        icons: {
        faDollarSign,
        faTruck, 
        faBicycle, 
        faStore, 
        faSyncAlt,
        faTrash,
        faCheckCircle,
        faExclamationTriangle,
        faChartLine,
        faDownload,
        faAngleRight,
        faAngleLeft
        },
    };
    },
    computed: {
        // 1. Number of orders where status is not fulfilled/closed (assuming 'open' means not fulfilled)
    openOrdersCount() {
        return this.filteredData.filter(item => item.status !== 'Fulfilled' && item.status !== 'Closed').length;
    },

    // 2. Average revenue (total settlement / number of orders)
    averageOrderRevenue() {
        if (!this.filteredData.length) return 0;
        const total = this.filteredData.reduce((sum, item) => sum + (item.total_settlement || 0), 0);
        return (total / this.filteredData.length) / 100; // Dividing by 100 for cents-to-dollars
    },

    // 3. Find the closest upcoming "order_due" date and calculate time remaining
    nextOrderDueText() {
        const now = new Date();
        const futureOrders = this.filteredData
            .map(item => new Date(item.order_due))
            .filter(date => date > now)
            .sort((a, b) => a - b);

        if (!futureOrders.length) return "No upcoming orders";

        const diffInMs = futureOrders[0] - now;
        const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInDays > 0) {
            return `${diffInDays}d ${diffInHours % 24}h`;
        }
        return `${diffInHours}h ${Math.floor((diffInMs / (1000 * 60)) % 60)}m`;
    },
    // Get filtered data based on search
    filteredData() {
        if (!this.filters.search) {
        return this.tableData;
        }
        
        const searchTerm = this.filters.search.toLowerCase();
        return this.tableData.filter(item => {
        const location = item.Location ? item.Location.toLowerCase() : '';
        const inStore = item['In Store'] ? item['In Store'].toString() : '';
        const chickenShackApp = item['Chicken Shack App'] ? item['Chicken Shack App'].toString() : '';
        const mobileApp = item['Mobile App'] ? item['Mobile App'].toString() : '';
        const totalSales = item['Total Sales'] ? item['Total Sales'].toString() : '';
        
        return (
            location.includes(searchTerm) ||
            inStore.includes(searchTerm) ||
            chickenShackApp.includes(searchTerm) ||
            mobileApp.includes(searchTerm) ||
            totalSales.includes(searchTerm)
        );
        });
    },

    // Total sales across all locations and origins - UPDATED for new columns
    totalSales() {
        return this.filteredData.reduce((sum, item) => sum + (item.Total_Sales || 0), 0);
    },

    // Unique locations
    uniqueLocations() {
        const locations = new Set();
        this.filteredData.forEach(item => locations.add(item.Location));
        return Array.from(locations);
    }
    },
    async mounted() {
    try {
        if (!this.user && this.getUser) {
            this.user = this.getUser();
        }

        try {
        const rawLocations = await apiHandler(() => Api.user[this.user.id].locations.Get());
        this.allowedIds = rawLocations.map(id => String(id));

    // 1. Filter the options
        this.myLocations = this.locationOptions.filter(item => {
            if (this.user.level === 7) {
                return true; // Admins get all locations
            }
            const locNumber = item.number; // Use the pre-parsed location number from the options
            return locNumber && this.allowedIds.includes(String(locNumber));
        });

        this.filters.location = this.myLocations[0].value; // Default to "All Locations" or first available
        
        } catch (error) {
        console.error('Error fetching user locations:', error);
        }
        finally {
            console.log('Allowed Location IDs for User:', this.myLocations);
            await this.fetchData();
        }
    } catch (error) {
        console.error('❌ Connection failed:', error);
    }
    },
    methods: {
    getSelectedLocationId() {
        const selectedCode = this.filters.location || '';
        const match = selectedCode.match(/^cs(\d{3})~/i);
        return match ? parseInt(match[1], 10) : null;
    },

    async getSelectedWeekData() {
        if (!this.filters.startDate) {
        return null;
        }

        const selectedDate = DateTime.fromISO(this.filters.startDate);
        if (!selectedDate.isValid) {
        return null;
        }

        return apiHandler(() => Api.weeks[selectedDate.weekYear][selectedDate.weekNumber].Get());
    },
    addDay() {
      const startDate = DateTime.fromISO(this.filters.startDate);
      const endDate = DateTime.fromISO(this.filters.endDate);
      
      this.filters.startDate = startDate.plus({ days: 1 }).toFormat('yyyy-MM-dd');
      this.filters.endDate = endDate.plus({ days: 1 }).toFormat('yyyy-MM-dd');
    },
    subtractDay() {
      const startDate = DateTime.fromISO(this.filters.startDate);
      const endDate = DateTime.fromISO(this.filters.endDate);
      
      this.filters.startDate = startDate.minus({ days: 1 }).toFormat('yyyy-MM-dd');
      this.filters.endDate = endDate.minus({ days: 1 }).toFormat('yyyy-MM-dd');
    },
    exportToCSV() {
        if (!this.filteredData.length) {
        this.$bvToast.toast('No data to export', {
            title: 'Export Error',
            variant: 'warning',
            solid: true
        });
        return;
        }

        try {
        // Use your table fields for headers and column order
        const headers = this.fields.map(field => field.label);
        const keys = this.fields.map(field => field.key);
        
        // Create CSV content
        let csvContent = headers.join(',') + '\n';
        
        // Add rows
        this.filteredData.forEach(item => {
            const row = keys.map(key => {
            const value = item[key] || '';
            
            // Handle different data types
            if (value === null || value === undefined) {
                return '';
            }
            
            // Format numbers (remove currency formatting for CSV)
            if (typeof value === 'number') {
                // Format to 2 decimal places
                return value.toFixed(2);
            }
            
            // Handle strings that might contain commas or quotes
            const stringValue = String(value);
            if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
                // Escape quotes and wrap in quotes
                return `"${stringValue.replace(/"/g, '""')}"`;
            }
            
            return stringValue;
            });
            
            csvContent += row.join(',') + '\n';
        });

        // Create and trigger download
        this.downloadCSV(csvContent, 'sales-data');
        
        } catch (error) {
        console.error('Error exporting CSV:', error);
        this.$bvToast.toast('Failed to export CSV: ' + error.message, {
            title: 'Export Error',
            variant: 'danger',
            solid: true
        });
        }
    },
    downloadCSV(csvContent, baseFilename) {
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        
        // Create filename with timestamp
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[:]/g, '-');
        const filename = `${baseFilename}_${timestamp}.csv`;
        
        if (navigator.msSaveBlob) {
        // For IE/Edge
        navigator.msSaveBlob(blob, filename);
        } else {
        // For other browsers
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        }
    },
    dateDisabled(ymd, date) {
        const weekday = date.getDay();      // Return `true` if the date should be disabled
        return weekday === 1 || weekday === 2 || weekday === 3 || weekday === 4 || weekday === 5 || weekday === 6;
    },
    handleMenuChange(menuName) {
        this.activeMenu = menuName;
        // Add any navigation logic here
        console.log('Menu changed to:', menuName);
    },
    formatDate(date) {
        return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
    },
    async fetchWestland(startDate, endDate) {
        console.log("Fetching Westland data...");
        
        try {
            const requestBody = {
                startDate: startDate + "T00:00:00.000Z",
                endDate: endDate + "T23:59:59.999Z",
                location: 10
            };
            
            // Use the new dedicated route
            const orderData = await apiHandler(() => 
                Api.orders.GetDetailedOrder.Post(requestBody)
            );
            
            console.log("Westland data:", orderData);
            return orderData;
            
        } catch (error) {
            console.error("Error fetching orders:", error);
            throw error;
        }
    },
    async fetchData() {
        this.loading = true;
        try {
            // Fetch catering snapshot data
            this.tableData = await apiHandler(() => 
                Api.clickhouse.cateringSnapshot.Get({
                    location: this.filters.location,
                    startDate: this.filters.startDate,
                    endDate: this.filters.endDate,
                })
            );
            // Fetch Westland orders
            if (this.filters.location === 'cs010~cc0cab7dc43218119bb8cf2f298860611' || this.filters.location === 'admin') {
                const westlandOrders = await this.fetchWestland(this.filters.startDate, this.filters.endDate);
                const groupedCateringOrders = this.groupCateringOrdersByOrderId(westlandOrders);
                const transformedWestlandData = this.transformWestlandToTableFormat(groupedCateringOrders);            // Append to existing tableData
                this.tableData.push(...transformedWestlandData);
            }                      
        } catch (error) {
            console.error('Error fetching data:', error);
            this.connectionError = error.message;
        } finally {
            this.loading = false;
        }
    },

    groupCateringOrdersByOrderId(orders) {
        if (!orders || !Array.isArray(orders)) return [];
        
        // Filter for catering orders only
        const cateringOrders = orders.filter(order => order.itemtype === 'Catering');
        
        // Group by orderId
        const grouped = {};
        
        cateringOrders.forEach(order => {
            const orderId = order.orderid;
            
            if (!grouped[orderId]) {
                // Create a new group entry
                grouped[orderId] = {
                    orderid: orderId,
                    location: order.location,
                    orderDate: order.orderDate,
                    total: 0,
                    quantity: 0,
                    items: [],
                    status: order.status,
                    pointofsale: order.pointofsale
                };
            }
            
            // Add item name to the list
            grouped[orderId].items.push(order.name);
            grouped[orderId].total += parseFloat(order.total) || 0;
            grouped[orderId].quantity += order.quantity || 0;
        });
        
        // Convert grouped object to array
        return Object.values(grouped);
    },

    transformWestlandToTableFormat(groupedOrders) {
        if (!groupedOrders || !Array.isArray(groupedOrders)) return [];
        
        return groupedOrders.map(order => {
            // Join item names with semicolon for your template
            const itemNames = order.items.join(';');
            
            return {
                /* eslint-disable @typescript-eslint/camelcase */
                location: 'Westland',
                order_started: this.formatWestlandDate(order.orderDate),
                order_due: null,
                time_remaining: null,
                Fulfilled: 'N/A',
                item_count: order.quantity || order.items.length,
                item_names: itemNames, // Semicolon-separated for your template
                order_notes: 'Westland Square Order',
                status: 'N/A',
                total_settlement: order.total*100 || 0
            };
        });
    },
    formatWestlandDate(dateString) {
        console.log('Formatting date:', dateString);
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }
    }
    };
</script>
  
<style scoped>
    .sales-cell {
    background-color: red !important;
    font-weight: bold;

    }
    .main-container {
    /* min-height: 100vh; */
    padding: 0.5rem 0rem 0.5rem 0rem;
    }

    .main-content {
    /* background-color: red; */
    flex-grow: 1;
    min-width: 0;
    margin: 0 1em;
    padding: 0em;
    }

    .content-card {
    border-radius: 0.5em !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    border: none;
    /* background-color: aquamarine; */
    width: 100%;
    margin: 0em;
    padding: 0em;
    }

    .touchpoint-dashboard {
    height: 100%;
    max-width: 1400px;
    padding: 0;
    }

    .dashboard-card {
    height: 100%;
    border-radius: inherit;
    /* background-color: violet; */
    width: 100%;
    margin: 0em;
    padding: 0em;
    padding: 1em 1em 0em 1em;

    }

    .card-body {
    padding: 0em;
    }

    .dashboard-header {
    padding-left: 0.5em;
    padding-right: 0.5em;
    }

    .sales-data {
    height: 20em;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    position: relative;
    overflow: hidden;
    width: 100%;
    }

    .origin-card {
    transition: all 0.3s ease;
    min-height: 4em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 10px;
    transition: transform 0.2s, box-shadow 0.2s;
    }

    .origin-card:hover {
    /* transform: translateY(-5px); */
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    }
    .origin-card.bg-primary {
    background-color: #3e187a;
    background-image: linear-gradient(316deg, #3e187a 0%, #994ecc 74%);
    }

    .origin-card.bg-success {
    background-color: #ffb347;
    background-image: linear-gradient(316deg, #F25424 0%, #ffc415 74%);
    }

    .origin-card.bg-info {
    background-color: #990000;
    background-image: linear-gradient(316deg, #990000 0%, #ff0000 74%);
    }

    .origin-card.bg-warning {
    background: rgb(0,127,255);
    background: linear-gradient(316deg, #2a52be 0%, #2391ff 74% );
    }

    .data-square {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    position: relative;
    /* overflow: hidden; */
    }

    /* New styles for data visualization */
    .top-store-card {
    border-left: 3px solid #28A745;
    }

    .worst-store-card {
    border-left: 3px solid #DC3545;
    }

    .store-icon {
    flex-shrink: 0;
    }

    .store-info {
    flex-grow: 1;
    }

    .legend-item {
    display: flex;
    align-items: center;
    margin-right: 15px;
    }

    .legend-color {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 8px;
    border: 1px solid rgba(0,0,0,0.2);
    }

    .legend-color.stars {
    background-color: rgba(255, 215, 0, 0.7);
    }

    .legend-color.plow-horses {
    background-color: rgba(144, 238, 144, 0.7);
    }

    .legend-color.puzzles {
    background-color: rgba(135, 206, 250, 0.7);
    }

    .legend-color.dogs {
    background-color: rgba(255, 99, 132, 0.7);
    }

    .legend-text {
    font-size: 12px;
    font-weight: 500;
    }

    .clearfix {
    clear: both;
    }

    .sales-table {
    margin-top: 0px;
    margin-bottom: 0;
    border: none !important;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    }

    .sales-table thead th {
    border: none !important;
    font-weight: 500;
    }

    .sales-table tbody td {
    border: none;
    padding: 14px 16px;
    vertical-align: middle;
    border-color: #f1f3f7;
    }

    .loading-indicator {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 3px solid rgba(255,255,255,.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    margin-left: 10px;
    }

    .spinning-icon {
    animation: spin 1s linear infinite;
    }

    @keyframes spin {
    to { transform: rotate(360deg); }
    }

    .dashboard-icon {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    opacity: 0.8;
    }

    .menu-icon {
    font-size: 1rem;
    opacity: 0.8;
    }
    .side-nav {
    float: left;
    width: 11em;
    flex-shrink: 0;
    height: fit-content;
    }

    .side-search{
    position: absolute;
    bottom: 0px;
    left: 1em;
    right: 1em;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2); 
    border-radius: 10px;
    border: none;
    padding: 0em;
    }
    .side-search > .my-search {
    border: 0em !important;
    height: 3em !important;
    }
</style>